import { EmptyState } from '@efdigital/ll-xceed-v2/components/application/empty-state';
import CoacheeSessionGroup from '@efdigital/ll-xceed-v2/components/coaching/coach/coachee-session-group.gts';
import type { CoachingCoachCoacheesCoacheeModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach/coachees/coachee';
import type { TOC } from '@ember/component/template-only';

interface CoachingCoachCoacheesCoacheeIndexSignature {
  Args: {
    model: CoachingCoachCoacheesCoacheeModel;
    controller: unknown;
  };
}

<template>
  {{#if @model.coachee.sessions.length}}
    <CoacheeSessionGroup
      @sessions={{@model.summary.upcoming}}
      @coach={{@model.coach}}
      @emptyMessage="No upcoming sessions with this coachee."
    />
  {{else}}
    <EmptyState
      @message="You have no sessions with this coachee yet."
      @icon="ph:calendar"
    />
  {{/if}}
</template> satisfies TOC<CoachingCoachCoacheesCoacheeIndexSignature>;
